import Contact from "../pages/contactUs";

export default [{ path: "/contact", component: Contact }];
